/** @jsx jsx */
import React, { useEffect } from 'react'
import { Box, jsx } from 'theme-ui'
import Header from '../Content/PageHeader/header'

const customStyles = `.chakra-portal, .chakra-popover__body, .chakra-popover__header, .chakra-input, .chakra-text, [class^='destini-css-'], [class^='chakra-popover__popper destini-css-'], [class^='chakra-popover__content destini-css-'], #Amazon>button, #Instacart>button {
  background-color: #aee0fd !important;
  color: #2B38BD !important;
  box-shadow: none !important;
  border-color: #2B38BD !important;
}
li[class^='destini-css-'], [class^='chakra-input destini-css-'], [class^='chakra-popover__content destini-css-']{
  border-color: #2B38BD !important;
}
[class^='chakra-popover__content destini-css-']{
  overflow: hidden
}
li[class^='destini-css-']{
  margin-right: 1rem;
}
[class^='chakra-button destini-css']{
  color: #2B38BD !important; 
}
svg {
  stroke: #2B38BD !important;
}
button[data-test="selected-products-badge"] > svg{
  color: #2B38BD !important;
}
div[data-test="selected-products-badge-count"], li[aria-label="Local Store Results"] > div > div > span{
  color: #fff !important;
  background-color: #2B38BD !important;
  z-Index: 5;
}
li[aria-label="Local Store Results"] > div > div > h3{
  z-Index: 5;

}
button[data-test="selected-products-badge"]:hover{
  background-color: #aee0fd !important;
}
button[aria-label="Select Specific Products"], button[aria-label="Find Products"]{
  color: #fff !important;
  background-color: #2B38BD !important;
}
}
`

export const Storelocator = ({ page }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      const destiny = document.querySelector('#destini-locator')?.shadowRoot
      const sheet = new CSSStyleSheet()
      sheet.replaceSync(customStyles)
      destiny?.adoptedStyleSheets.push(sheet)
    }, 2000)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Box
      sx={{
        mt: '2rem',
      }}
    >
      <Header section={{ title: 'Store Finder' }} />
      <div
        APOG=""
        id="destini-locator"
        class="destini-locator-class"
        locator-id="1551"
        alpha-code="60F"
        locator-name="Goodles OCL"
        client-id="goodles"
      ></div>
    </Box>
  )
}
